import { StyleSheet, Text, View } from '@react-pdf/renderer'
import PDFBorderedList from '@/components/ReportPDF/PDFBorderedList'
import PDFPage from '@/components/ReportPDF/PDFPage'
import baseStyles from '@/components/ReportPDF/styles'
import { parseDateToTaiwanDate } from '../../TaiwanDateConvert'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'

const styles = StyleSheet.create({ listText: { flex: 1 }, ...baseStyles })

const DisclaimerPage = ({ reportData }) => {
  const {
    reprotDao,
    phishType,
    secondaryCompanyNickname,
    secondaryCompanyFullname,
    generateStartDate,
    generateEndDate,
  } = reportData || {}
  const { companyName, version } = reprotDao || {}
  const service = phishType

  return (
    <PDFPage reportData={reportData}>
      <View>
        <PDFParagraph>
          <Text style={{ fontWeight: 'bold' }}>法律聲明</Text>
        </PDFParagraph>
        <PDFParagraph>
          {'    '}本文件內含機密及版權所有的資訊，僅供
          <Text>{companyName}</Text>
          使用，嚴禁未經授權者使用或複製本文件。
        </PDFParagraph>
        <PDFParagraph>
          {'    '}本測試是由<Text>{secondaryCompanyNickname}</Text>的資訊安全專家所執行。
        </PDFParagraph>
        <PDFParagraph>
          {'    '}
          本次的社交工程<Text>{service}</Text>
          演練服務測試出所有截至本文件產出前已知的相關資訊。隨著新的社交工程郵件威脅持續產生，建議定期執行社交工程郵件演練，並且維持每年檢測1-2次的頻率。
        </PDFParagraph>
        {/* <PDFParagraph> */}
        <Text style={{ fontWeight: 'bold' }}>關於本文件</Text>
        {/* </PDFParagraph> */}
        <PDFBorderedList
          name={'docinfo'}
          items={[
            <>
              <Text style={[styles.listText, { fontWeight: 'bold' }]}>文件類別</Text>
              <Text style={styles.listText}>
                社交工程<Text>{service}</Text>測試服務結果及分析報告書
              </Text>
            </>,
            <>
              <Text style={[styles.listText, { fontWeight: 'bold' }]}>客戶</Text>
              <Text style={[styles.listText]}>{companyName}</Text>
            </>,
            <>
              <Text style={[styles.listText, { fontWeight: 'bold' }]}>執行顧問</Text>
              <Text style={[styles.listText]}>
                <Text>{secondaryCompanyFullname}</Text>
              </Text>
            </>,
            <>
              <Text style={[styles.listText, { fontWeight: 'bold' }]}>文件版本</Text>
              <Text style={[styles.listText]}>{version}</Text>
            </>,
            <>
              <Text style={[styles.listText, { fontWeight: 'bold' }]}>製作日期</Text>
              <Text style={[styles.listText]}>
                {parseDateToTaiwanDate(generateStartDate)} -{' '}
                {parseDateToTaiwanDate(generateEndDate)}
              </Text>
            </>,
          ]}
        />
      </View>
    </PDFPage>
  )
}

export default DisclaimerPage
